<template>
    <div>
        <page-header :title="$t('pages.admin.livestream.announcements.index.title')" icon-class="mdi mdi-record">
            <div class="text-right">
                <router-link tag="a" :to="{name: 'admin.livestream.announcement.add'}" class="text-primary font-weight-bold">
                    <i class="mdi mdi-plus"></i> {{ $t('actions.create') }}
                </router-link>
            </div>
        </page-header>

        <div class="card shadow-sm">
            <div class="card-body">
                <h5 class="card-title">{{ $t('pages.admin.livestream.announcements.index.title_upcoming') }}</h5>

                <announcement-table :announcements="announcementsUpcoming" :empty-text="$t('pages.admin.livestream.announcements.index.no_upcoming')" @reload="getUpcomingAnnouncements"/>

                <div class="mt-3">
                    <pagination :data="paginationDataUpcoming" @pagination-change-page="getUpcomingAnnouncements"></pagination>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-body">
                <h5 class="card-title">{{ $t('pages.admin.livestream.announcements.index.title_past') }}</h5>

                <announcement-table :announcements="announcementsPast" :empty-text="$t('pages.admin.livestream.announcements.index.no_past')" @reload="getPastAnnouncements"/>

                <div class="mt-3">
                    <pagination :data="paginationDataPast" @pagination-change-page="getPastAnnouncements"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../../Includes/PageHeader";
import AdminLiveStreamAnnouncementRepository
    from "../../../../repositories/Admin/AdminLiveStreamAnnouncementRepository";
import AnnouncementTable from "./Includes/AnnouncementTable";
export default {
    name: "LiveStreamAnnouncementIndex",
    components: {AnnouncementTable, PageHeader},
    data: () => ({
        paginationDataUpcoming: {},
        announcementsUpcoming: [],

        paginationDataPast: {},
        announcementsPast: [],
    }),
    mounted() {
        this.getUpcomingAnnouncements(1);
        this.getPastAnnouncements(1);
    },
    methods: {
        getUpcomingAnnouncements(page = 1) {
            AdminLiveStreamAnnouncementRepository
                .getUpcoming(page)
                .then((res) => {
                    this.paginationDataUpcoming = res.data.meta;
                    this.announcementsUpcoming = res.data.data;
                });
        },

        getPastAnnouncements(page = 1, $type = 'upcoming') {
            AdminLiveStreamAnnouncementRepository
                .getPast(page)
                .then((res) => {
                    this.paginationDataPast = res.data.meta;
                    this.announcementsPast = res.data.data;
                });
        }
    }
}
</script>

<style scoped>

</style>
